module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-18.5f0bd885.jpg";